export default "__VITE_ASSET__Bwm$hSGS__"